// TOKEN-GAP(core): refactor with theme variables

.textarea {
  display: inline-block;
  width: 100%;

  &--disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  &__field {
    width: 100%;
    min-height: 180px;
    padding: 12px;
    font-family: inherit;
    font-size: 16px;
    line-height: 1.5;
    color: var(--text-color-primary);
    border: var(--border-size-sm) solid var(--border-color-primary);
    background-color: var(--color-neutral-white);
    border-radius: var(--radius-size-md);
    resize: vertical;
    transition: all 0.2s ease-in-out;

    &::placeholder {
      color: var(--text-color-tertiary);
    }

    &:hover {
      // border-color: $brand-primary-main;
    }

    &:focus {
      outline: none;
    }

    &:focus-visible {
      outline: 2px solid var(--color-brand-primary-main);
      outline-offset: 2px;
      border-color: var(--color-brand-primary-main);
    }

    &:disabled {
      background-color: var(--background-color-secondary);
      border-color: var(--border-color-secondary);
      cursor: not-allowed;
    }
  }

  /*
   * Match me-input: reserve no layout when the message is hidden (visibility:hidden still occupies space).
   */
  .form-error-message {
    display: none;
    min-height: 1.5rem;

    &.error-visible {
      display: block;
    }
  }

  .error-visible {
    visibility: visible;
    opacity: 1;
  }

  .error-hidden {
    visibility: hidden;
    opacity: 0;
  }
}

.textarea__label {
  display: inline-flex;
  padding-bottom: var(--spacing-sm);
}

.textarea__field--error {
  border-color: var(--color-system-error);
}
